import { createSlice } from '@reduxjs/toolkit';
import { fetchVaultsThunk } from './thunks/fetch-vaults-thunk';
import type { AdviserSharedVault } from '@syfo/types/adviser.types';

export interface VaultsState {
  list: AdviserSharedVault[];
  isLoading: boolean;
  error: string | null;
  lastFetchedAt: string | null;
}

const initialState: VaultsState = {
  list: [],
  isLoading: false,
  error: null,
  lastFetchedAt: null,
};

const vaultsSlice = createSlice({
  name: 'vaults',
  initialState,
  reducers: {
    // Reset vaults list state
    resetVaults: (state) => {
      state.list = [];
      state.error = null;
      state.lastFetchedAt = null;
    },
    // Clear error state
    clearVaultsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch vaults list
      .addCase(fetchVaultsThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchVaultsThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
        state.lastFetchedAt = new Date().toISOString();
        state.error = null;
      })
      .addCase(fetchVaultsThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch vaults';
      });
  },
});

export const { resetVaults, clearVaultsError } = vaultsSlice.actions;
export default vaultsSlice.reducer;
